import React, { useMemo } from 'react'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import LuxPlusInclusions from 'luxPlus/components/LuxPlusInclusions'
import InclusionsSection from '../FlashHotel/InclusionsSection'
import { useOfferInclusions } from 'hooks/useOfferInclusions'
import moment from 'moment'
import { getInclusionsViewableLuxPlusTier } from 'selectors/luxPlusSelectors'
import LargeContentToggle from 'components/Common/LargeContentToggle'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

const INCLUSIONS_COLLAPSED_MAX_HEIGHT = 80

interface MappedProps {
  checkIn?: string
  duration?: number
  inclusionsViewableLuxPlusTier: App.MembershipSubscriptionTier
}

interface Props extends MappedProps {
  offer: App.Offer
  packageOption: App.OfferPackageOptionView
  open?: boolean
  onToggle?: () => void
}

function MultipleRoomsInclusions(props: Props) {
  const {
    offer,
    checkIn,
    duration,
    packageOption,
    open,
    onToggle,
  } = props

  const pkg = packageOption.package
  const checkInMoment = useMemo(() => checkIn ? moment(checkIn) : undefined, [checkIn])
  const checkOutMoment = useMemo(() => checkInMoment?.clone().add(duration, 'days'), [checkInMoment, duration])
  const { inclusions, bonusInclusions, luxPlusInclusions } = useOfferInclusions(pkg, { checkIn: checkInMoment, checkOut: checkOutMoment })

  return (
    <LargeContentToggle
      maxHeight={INCLUSIONS_COLLAPSED_MAX_HEIGHT}
      showMoreText="View more inclusions"
      showLessText="View less inclusions"
      open={open}
      onToggle={onToggle}
    >
      <VerticalSpacer gap={8}>
        {!!luxPlusInclusions.length && (
          <LuxPlusInclusions
            luxPlusInclusions={luxPlusInclusions}
            accommodationOffer={offer}
            hideUpsellModal
          />
        )}
        <InclusionsSection inclusions={inclusions} bonusInclusions={bonusInclusions} />
      </VerticalSpacer>
    </LargeContentToggle>
  )
}

export default withOfferPageAndReduxState((state, appState): MappedProps => ({
  checkIn: state.checkInDate,
  duration: state.duration,
  inclusionsViewableLuxPlusTier: getInclusionsViewableLuxPlusTier(appState),
}), MultipleRoomsInclusions)
